import styled from 'styled-components';
import theme from '../../const/theme';
import logo from '../../img/bg/cardbg.jpeg';


export const PartnersContainer = styled.div`
    max-width: 1270px;
    width: 100%;
    background-color: ${theme.COLORS.GRAY};
    border-radius: 50px;
    margin: 25px auto;
    padding: 3em;

    @media screen and (max-width: 768px){
        padding: 0;
        max-width: 100;

    }
`

export const PartnersTextWrapper = styled.div`
    text-align: center;
`

export const PartnersWrapper = styled.div`
    width: 100%;
`

export const PartnersRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 90px 30px;
    @media screen and (max-width: 768px){
        flex-direction: column;
        justify-content: center;
        padding: 0;
        align-items: center;
    }
`


export const PartnersCard = styled.div`
    background-color: white;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 2rem;
  box-shadow: 0px 1rem 1.5rem rgba(0,0,0,0.5);
  padding-bottom: 20px;
  min-width: 30%;
  margin: 0 1rem;
  margin-bottom: 2rem;

    &:hover{
        transform: scale(1.02);
        transition: all 0.2s ease-in-out;
        cursor: pointer;
    }  
`
export const PartnersCardBanner = styled.div`
     background-image: url(${logo});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    height: 11rem;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    box-sizing: border-box;
`

export const PartnersCardImg= styled.img`
      background-color: white;
      width: 8rem;
      height: 8rem;
      box-shadow: 0 0.5rem 1rem rgba(0,0,0, 0.3);
      border-radius: 50%;
      transform: translateY(50%);
      transition: transform 200ms cubic-bezier(0.18, 0.89, 0.32, 1.28);

      &:hover{
          transform: translateY(50%) scale(1.3);
      }
   
`
export const PartnersIconContainer = styled.div`
    height: 130px;
`

export const PartnersIcon = styled.img`
    width: 260px;
    margin: 35px 0px 30px 0px;

`

export const PartnersH1 = styled.h1`
    font-family: 'Roboto-regular', sans-serif;     
    font-size: 2.7rem;
    color: ${({textWhite}) => (textWhite ? '#FFF' : theme.COLORS.PRIMARY)};
    margin-bottom: 25px;
    @media screen and (max-width: 768px){
        font-size: 2rem;
        margin-bottom: 30px; 
        text-align: center;
        padding-top: 30px;

    }
`
export const PartnersH2 = styled.h2`
    font-family: 'Barlow Condensed', sans-serif; 
       text-align: center;
        padding: 0 2rem 0.5rem;
        margin-top: 100px;
`
export const PartnersP = styled.p`
      color: #A0A0A0;
    font-size: 0.85rem;
    text-align: center;
    padding: 0 2rem 1.2rem;
`
